// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xd2ze","imageContainer":"styles_imageContainer__EBTkD","image":"styles_image__iEIu8","mobileDetails":"styles_mobileDetails__dJpcO"};